import commonGetters from '@/store/data/common/getters'

const getters = {}

export default { ...commonGetters, ...getters }
